/** Min/max playbook count for playbook-based pricing (used in PlanSelection and PlaybookCountControl). */
export const MIN_PLAYBOOKS = 1
export const MAX_PLAYBOOKS = 1000

export enum TCSBillingTier {
  STARTER = 'starter',
  PRO = 'pro',
  POWER = 'power'
}


export const TCSBillingPlans = [
  {
    tier: TCSBillingTier.STARTER,
    name: 'Starter',
    price: 150,
    credentials: 3,
    features: ['Up to 3 credentials', 'Unlimited Workflows', 'Unlimited Users'],
    color: 'text-accent bg-accent',
    popular: false,
  },
  {
    tier: TCSBillingTier.PRO,
    name: 'Pro',
    price: 300,
    credentials: 10,
    features: ['Up to 10 credentials', 'Unlimited Workflows', 'Unlimited Users'],
    color: 'text-purple-500 bg-purple-500',
    popular: true,
  },
  {
    tier: TCSBillingTier.POWER,
    name: 'Power',
    price: 500,
    credentials: 'Unlimited',
    features: [
      'Unlimited credentials',
      'Dedicated Support',
      'Unlimited Workflows',
      'Unlimited Users',
    ],
    color: 'text-green-500 bg-green-500',
    popular: false,
  },
]
